import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Status from "@/pages/Status";
import DashboardLayout from "@/pages/DashboardLayout";
import Studio from "@/pages/dashboard/Studio";
import AutoStudio from "@/pages/dashboard/AutoStudio";
import Compare from "@/pages/dashboard/Compare";
import CodeAgent from "@/pages/dashboard/CodeAgent";
import Overview from "@/pages/dashboard/Overview";
import AdminAnalytics from "@/pages/dashboard/AdminAnalytics";
import Credits from "@/pages/dashboard/Credits";
import Developers from "@/pages/dashboard/Developers";
import Docs from "@/pages/dashboard/Docs";
import Settings from "@/pages/dashboard/Settings";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center bg-background text-muted-foreground">Chargement…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/status" element={<Status />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/app" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Studio />} />
              <Route path="auto" element={<AutoStudio />} />
              <Route path="comparateur" element={<Compare />} />
              <Route path="code" element={<CodeAgent />} />
              <Route path="apercu" element={<Overview />} />
              <Route path="credits" element={<Credits />} />
              <Route path="developpeurs" element={<Developers />} />
              <Route path="docs" element={<Docs />} />
              <Route path="admin" element={<AdminAnalytics />} />
              <Route path="parametres" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
